import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";
import { formatDate } from "../../../uteis/dateUtils";
import { formatPhoneNumber } from "../../../uteis/formatPhoneNumber";

export const buscarPostagensService = async () => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/postagens/active/post`;
    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      const postagensArray = response.data.map((postagem: any) => {
        return {
          key: postagem.id,
          nome: postagem?.Leads?.nome || "Sem nome",
          telefone: postagem?.Leads?.celular
            ? formatPhoneNumber(postagem.Leads.celular)
            : "-",
          tipo:
            postagem?.Leads?.tipo === "LEAD"
              ? "Lead"
              : postagem?.Leads?.tipo === "REVENDEDOR"
              ? "Revendedor"
              : postagem?.Leads?.tipo === "PROPRIETARIO"
              ? "Proprietário"
              : postagem?.Leads?.tipo === "GOLPISTA"
              ? "Golpista"
              : "Sem informações",
          nomeEmpreend: postagem?.Empreendimento?.nome || "Sem empreendimento",
          tipoInteresse:
            postagem?.tipoInteresse === "PROCURA"
              ? "Procura"
              : postagem?.tipoInteresse === "DISPONIBILIZA"
              ? "Disponibiliza"
              : "-",
          troca: postagem?.troca === 0 ? "Não" : "Sim",
          aluguel: postagem?.aluguel === 0 ? "Não" : "Sim",
          compra: postagem?.compra === 0 ? "Não" : "Sim",
          venda: postagem?.venda === 0 ? "Não" : "Sim",
          dataIni: postagem?.dataIni ? formatDate(postagem.dataIni) : "-",
          dataFim: postagem?.dataFim ? formatDate(postagem.dataFim) : "-",
          fonte: postagem?.Fonte?.nome || "Sem fonte",
          grupo: postagem?.Grupo?.nome || "-", // ✅ proteção contra null
          dataDivulgacao: postagem?.dataDivulgacao
            ? formatDate(postagem.dataDivulgacao)
            : "-",
          observacao: postagem?.observacoes || "",
        };
      });

      return postagensArray;
    } catch (error) {
      console.error("Erro ao buscar postagens:", error);
    }
  }
};
